module.exports = "pegasus/assets/preview-18.png";